import React, { Component } from 'react';
const iconTiner = {
    background: '#ffffff',
    borderRadius: '50%',
    width: 35,
    height: 'auto',
    padding: '10px'
};

const iconEmoji = {
    background: '#ffffff',
    borderRadius: '50%',
    width: 35,
    height: 35,
    padding: '10px',
    textAlign: 'center'
};

export default class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = { tinder_buttons: true };
    }

    renderTinderButtons = () => {
        return (
            <footer className="footer-container">
                <img
                    className="pointer"
                    onClick={() => this.setState({ tinder_buttons: !this.state.tinder_buttons })}
                    style={iconTiner}
                    alt="nope"
                    src={require('../images/nope.png')}
                />
                <img
                    className="pointer"
                    style={iconTiner}
                    alt="super-like"
                    src={require('../images/super_like.png')}
                    onClick={() => this.props.action()}
                />
                <img
                    className="pointer"
                    style={iconTiner}
                    alt="like"
                    src={require('../images/like.png')}
                    onClick={() => this.props.action()}
                />
            </footer>
        );
    };

    renderSocialButtons = () => {
        return (
            <footer className="footer-container">
                <img
                    className="pointer"
                    onClick={() => this.setState({ tinder_buttons: !this.state.tinder_buttons })}
                    style={iconTiner}
                    alt="nope"
                    src={require('../images/nope.png')}
                />
                <a href="https://github.com/jeremydanner" rel="noopener noreferrer" target="_blank">
                    <img
                        style={{ width: 51, height: 51 }}
                        alt="github"
                        src={require('../images/github.png')}
                    />
                </a>

                <a
                    href="https://www.linkedin.com/in/jeremydanner/"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <img
                        style={{ width: 51, height: 51 }}
                        alt="linkedin"
                        src={require('../images/linkedin.png')}
                    />
                </a>

                <a
                    href="mailto:jeremydanner2@gmail.com?Subject=Tänk%20på%20att%20jag%20är%20nöjd%20med%20mitt%20jobb%20som%20jag%20har%20idag,%20du%20måste%20locka%20med%20något%20riktigt%20bra%20i%20så%20fall!%20😅"
                    style={iconEmoji}
                >
                    <span role="img" aria-label="emoji">
                        📨
                    </span>
                </a>
                <a href="tel:+46762281885" style={iconEmoji}>
                    <span role="img" aria-label="emoji">
                        📱
                    </span>
                </a>
            </footer>
        );
    };
    render() {
        return this.state.tinder_buttons ? this.renderTinderButtons() : this.renderSocialButtons();
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js